module.exports = __webpack_public_path__ + "media/images/pokerroom/lotos/step2-pict01-8108e7b5df90f52381593a339da20079.jpg";